import { render, staticRenderFns } from "./None.vue?vue&type=template&id=1aa01fc4&"
import script from "./None.vue?vue&type=script&lang=ts&"
export * from "./None.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports